export default "__VITE_ASSET__BtEHW7zu__"